const EMPLOYEE_DEPUTES_TABLE_READY = "employeeDeputes-table-ready"
const SEARCH_TEXT_STATE = "employeeDeputes-table-search-text-state"
const ROWS_PER_PAGE_STATE = "employeeDeputes-table-rows-per-page-state"
const PAGINATION_STATE = "employeeDeputes-table-pagination-state"

const EMPLOYEE_DEPUTE_ID_FOR_ACTION = "employeeDeputes-table-employee-depute-id-for-action"

const ADD_EMPLOYEE_DEPUTE_READY = "eemployeeDeputes-table-add-employee-depute-ready"


const PREVIOUS_EMPLOYEE_DEPUTE_FILTER_CITY = "previous-employee-depute-filter-city"

const PREVIOUS_EMPLOYEE_DEPUTE_FILTER_KITCHEN_ID = "previous-employee-depute-filter-kitchen-id-action"

const PREVIOUS_EMPLOYEE_DEPUTE_FILTER_START_DATE= "previous-employee-depute-filter-start-date"
const PREVIOUS_EMPLOYEE_DEPUTE_FILTER_END_DATE= "previous-employee-depute-filter-end-date"



const initialState = {
    isEmployeeDeputeTableReady: true,
    isAddEmployeeDeputeReady:true,
    employeeDeputes: {},
    
    employeeDeputeSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterCity : "",
    previousFilterKitchenId : "",
    previousFilterStartDate : "",
    previousFilterEndDate : "",


    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case EMPLOYEE_DEPUTES_TABLE_READY:
            return Object.assign({}, state, { isEmployeeDeputeTableReady: action.payload })
        case ADD_EMPLOYEE_DEPUTE_READY:
            return Object.assign({}, state, { isAddEmployeeDeputeReady: action.payload })


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case EMPLOYEE_DEPUTE_ID_FOR_ACTION:
            return Object.assign({}, state, {employeeDeputeSelectedId:action.payload})

        case PREVIOUS_EMPLOYEE_DEPUTE_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})

        case PREVIOUS_EMPLOYEE_DEPUTE_FILTER_KITCHEN_ID:
            return Object.assign({}, state, {previousFilterKitchenId:action.payload})

        case PREVIOUS_EMPLOYEE_DEPUTE_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})

        case PREVIOUS_EMPLOYEE_DEPUTE_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})

        default:
        return state
    
    }

}

export function employeeDeputeTableReady(data) {
    return {
        type: EMPLOYEE_DEPUTES_TABLE_READY,
        payload: data
    }
}


export function addEmployeeDeputeReady(data) {
    return {
        type: ADD_EMPLOYEE_DEPUTE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function employeeDeputeIdForAction(employeeDeputeId){
    return{
        type:EMPLOYEE_DEPUTE_ID_FOR_ACTION,
        payload:employeeDeputeId
    }
}

export function previousFilterCity(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_DEPUTE_FILTER_CITY,
        payload:filterVal
    }
}


export function previousFilterKitchenId(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_DEPUTE_FILTER_KITCHEN_ID,
        payload:filterVal
    }
}


export function previousFilterStartDate(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_DEPUTE_FILTER_START_DATE,
        payload:filterVal
    }
}


export function previousFilterEndDate(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_DEPUTE_FILTER_END_DATE,
        payload:filterVal
    }
}




// WEBPACK FOOTER //
// ./src/modules/Employee Depute/redux/employee_depute.js